import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PhotoGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const gallery = [
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass leading tech workshop and mentoring aspiring developers",
    category: "Mentorship",
    title: "Leading Tech Workshop"
  },
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass collaborating with professional team on innovative projects",
    category: "Team Leadership",
    title: "Team Collaboration"
  },
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass working on business strategy with diverse team",
    category: "Entrepreneurship",
    title: "Business Strategy Session"
  },
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass coding on multiple monitors in modern tech workspace",
    category: "IT Engineering",
    title: "Development Work"
  },
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass typing code on laptop keyboard with colorful programming syntax visible on screen",
    category: "Creative Direction",
    title: "Ed Pulse Creative Session"
  },
  {
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass celebrating successful project launch with team",
    category: "Success Stories",
    title: "Project Launch Celebration"
  }];


  return (
    <section className="py-16 lg:py-24 bg-card">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 lg:mb-16">

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Camera" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Gallery</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">Professional Moments</h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Capturing the journey through technology, business, and creative excellence
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {gallery?.map((item, index) =>
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            whileHover={{ y: -8, transition: { duration: 0.3 } }}
            className="group cursor-pointer"
            onClick={() => setSelectedImage(item)}>

              <div className="relative aspect-[4/3] rounded-xl lg:rounded-2xl overflow-hidden bg-muted">
                <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 lg:p-6">
                    <span className="inline-block px-3 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full mb-2">
                      {item?.category}
                    </span>
                    <h3 className="text-base md:text-lg font-semibold text-white">{item?.title}</h3>
                  </div>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Icon name="Maximize2" size={20} color="var(--color-foreground)" />
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>
      <AnimatePresence>
        {selectedImage &&
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[300] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}>

            <button
            className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close lightbox">

              <Icon name="X" size={24} color="white" />
            </button>

            <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="max-w-5xl w-full"
            onClick={(e) => e?.stopPropagation()}>

              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden mb-4">
                <Image
                src={selectedImage?.image}
                alt={selectedImage?.imageAlt}
                className="w-full h-full object-contain" />

              </div>
              <div className="text-center">
                <span className="inline-block px-4 py-2 bg-primary text-primary-foreground text-sm font-medium rounded-full mb-2">
                  {selectedImage?.category}
                </span>
                <h3 className="text-xl md:text-2xl font-semibold text-white">{selectedImage?.title}</h3>
              </div>
            </motion.div>
          </motion.div>
        }
      </AnimatePresence>
    </section>
  );


};

export default PhotoGallery;